import { useAppSelector } from 'app/redux/store';
import { INTERNAL_USER_EMAIL_DOMAIN } from './useIsInternalUser.constants';

export const useIsInternalUser = () => {
  const { details } = useAppSelector(state => state.profile.user);
  const { email } = details ?? {};
  if (!email) return false;
  return email.toLowerCase().includes(INTERNAL_USER_EMAIL_DOMAIN);
};
